import { createService } from './config/axios';
import {
  TGetNoticeListParams,
  TGetNoticeListResponse,
  TPostNoticeResponse,
  TGetNoticeResponse,
} from '../types/apis/notice';
import qs from 'qs';

export const postNotice = async (data: FormData) =>
  await createService<TPostNoticeResponse>({
    url: '/notice',
    options: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'post',
      data,
    },
  });

export const getNoticeList = async (params: TGetNoticeListParams) => {
  const queryString = qs.stringify(params);

  return await createService<TGetNoticeListResponse>({
    url: `/notice?${queryString}`,
    options: {
      method: 'get',
    },
  });
};

export const getNotice = async (noticeId: number) =>
  await createService<TGetNoticeResponse>({
    url: `/notice/${noticeId}`,
    options: {
      method: 'get',
    },
  });

export const putNotice = async (noticeId: number, data: FormData) =>
  await createService({
    url: `/notice/${noticeId}`,
    options: {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'put',
      data,
    },
  });

export const deleteNotice = async (noticeId: number) =>
  await createService({
    url: `/notice/${noticeId}`,
    options: {
      method: 'delete',
    },
  });
